import React from "react";
import { PackageCheck, CheckCircle2, Truck, Archive, Layers } from "lucide-react";
import { StatCard, StatCardSkeleton } from "src/components/ui/statCard";

export interface PalletStatsCardsProps {
  isLoading: boolean;
  casesReady: number;
  palletsBuilding: number;
  palletsComplete: number;
  palletsInTransit: number;
  palletsBookedIn: number;
}

export const PalletStatsCards: React.FC<PalletStatsCardsProps> = ({
  isLoading,
  casesReady,
  palletsBuilding,
  palletsComplete,
  palletsInTransit,
  palletsBookedIn
}) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
    {isLoading ? (
      <>
        <StatCardSkeleton />
        <StatCardSkeleton />
        <StatCardSkeleton />
        <StatCardSkeleton />
        <StatCardSkeleton />
      </>
    ) : (
      <>
        <StatCard
          icon={PackageCheck}
          title="Cases Ready"
          value={casesReady}
          accentClass="bg-emerald-500"
          iconBgClass="bg-emerald-50"
          iconColorClass="text-emerald-600"
        />
        <StatCard
          icon={Layers}
          title="Pallets Building"
          value={palletsBuilding}
          accentClass="bg-indigo-500"
          iconBgClass="bg-indigo-50"
          iconColorClass="text-indigo-600"
        />
        <StatCard
          icon={CheckCircle2}
          title="Pallets Complete"
          value={palletsComplete}
          accentClass="bg-blue-500"
          iconBgClass="bg-blue-50"
          iconColorClass="text-blue-600"
        />
        <StatCard
          icon={Truck}
          title="In Transit"
          value={palletsInTransit}
          accentClass="bg-amber-500"
          iconBgClass="bg-amber-50"
          iconColorClass="text-amber-600"
        />
        <StatCard
          icon={Archive}
          title="Booked In"
          value={palletsBookedIn}
          accentClass="bg-green-500"
          iconBgClass="bg-green-50"
          iconColorClass="text-green-600"
        />
      </>
    )}
  </div>
);
